import React from "react";
import { NavLink } from "react-router-dom";
import { ReactSVG } from "react-svg";

const SideCTA = () => {
  return (
    <div className=" flex md:flex-col flex-row items-center md:gap-3 gap-[6px] md:bg-transparent bg-transparent md:p-0 p-2 md:shadow-none ">
      <NavLink
        to="/contact-us"
  className="xl:px-3 px-2 xl:py-2 py-1.5 xl:text-[1rem] lg:text-[.85rem] text-[.8rem] xl:rounded-xl rounded-lg bg-[#00643B] border border-[#ffffff] font-semibold text-white hover:text-[#00643B] hover:bg-white hover:border-[#00643B]"
      >
        <span>Contact Us</span>
      </NavLink>
    </div>
  );
};

export default SideCTA;
